"use client";
import { getUserSubPlan } from "@/lib/subscription";
import { Box, Button, Typography } from "@mui/material";
import Link from "next/link";
import React, { useEffect } from "react";
import { useTranslations } from "next-intl";

export default function UnlockSignalBanner() {
  const t = useTranslations();
  const [sub, setSub] = React.useState<any>(undefined);
  useEffect(() => {
    loadData();
  }, []);

  async function loadData() {
    const res = await getUserSubPlan();
    setSub(res);
  }

  if (sub || sub === undefined) {
    return <></>;
  }

  return (
    <Box
      sx={{
        position: "sticky",
        top: "5.5rem",
        zIndex: 1005,
        width: "100%",
        pb: "0.5rem",
        mb: "2.88rem",
        bgcolor: "background.default",
      }}>
      <Box
        sx={{
          borderRadius: "0.75rem",
          border: `1px solid #A27D49`,
          px: 3,
          py: 1.5,
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: "center",
          justifyContent: "space-between",
          gap: { xs: "0.5rem", sm: "1.75rem" },
        }}>
        <Typography sx={{ color: "text.secondary", fontSize: "var(--font-size-xs)" }}>
          {t.rich("Analytics.unlock.bannerText", { br: () => <br /> })}
        </Typography>

        <Link href="/membership" style={{ textDecoration: "none" }}>
          <Button variant="contained" color="primary" sx={{ px: 3, py: 1, fontSize: "var(--font-size-xs)" }}>
            {t("Analytics.unlock.cta")}
          </Button>
        </Link>
      </Box>
    </Box>
  );
}
